import { useState } from "react";

const AutoCompleteSelect = ({
  options = [],
  labelKey = "label",
  valueKey = "value",
  placeholder = "Select an option",
  onSelect,
  width = "100%",
}) => {
  const [query, setQuery] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedValue, setSelectedValue] = useState(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    // Filter options based on input
    if (value.trim() === "") {
      setFilteredOptions([]);
    } else {
      const filtered = options.filter((item) =>
        item[labelKey].toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  };

  const handleSelect = (item) => {
    setSelectedValue(item[valueKey]);
    setQuery(`${item[labelKey]} - GHC${item.field_investigation_price}`);
    setFilteredOptions([]);
    if (onSelect)
      onSelect(item[valueKey], item[labelKey], item.field_investigation_price);
    // if (onSelect) onSelect(item[valueKey], item[labelKey]);
  };

  return (
    <div>
      <input
        type="text"
        value={query}
        onChange={handleInputChange}
        placeholder={placeholder}
        required
        className="autocomplete"
      />
      {filteredOptions.length > 0 && (
        <ul
          style={{
            width: "100%",
            background: "#fff",
            border: "1px solid #ccc",
            fontSize: "16px",
            listStyleType: "none",
            padding: "0",
            margin: "0",
            overflowY: "auto",
            zIndex: 1,
          }}
        >
          {filteredOptions.map((item) => (
            <li
              key={item[valueKey]}
              onClick={() => handleSelect(item)}
              style={{
                padding: "20px 16px",
                cursor: "pointer",
              }}
            >
              {item[labelKey]} - GHC{item.field_investigation_price}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteSelect;
